import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { GuidanceTextResponse } from '../../utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { RenderHtml } from './utils';

interface ShowGuidanceTextProps {
  questionId: number;
  sectionId?: FeedbackSectionId;
  guidanceText: GuidanceTextResponse | undefined;
}

const StyledDiv = styled.div`
  max-width: 720px;
  margin: 0 auto ${SPACERS.tiny} auto;
  a {
    color: ${COLORS.ctaPrimary};
  }
`;

const ShowGuidanceText: React.FC<ShowGuidanceTextProps> = ({
  questionId,
  guidanceText,
}) => {
  const guidance = guidanceText?.[questionId];
  return (
    <StyledDiv>
      <TrueImpactText
        align="center"
        variant="body-bold"
        color="grayDark"
        className="guidance-text"
      >
        <RenderHtml text={guidance} />
      </TrueImpactText>
    </StyledDiv>
  );
};

export default ShowGuidanceText;
